export class OtpMessage {
  public otpTimeExpire = `If employee has not received OTP code then contact his/her HR/Authorized personnel to update his/her mobile number in MetLife.`
    public otpLeftTime = 120;

  }